import { makeAutoObservable, runInAction } from 'mobx';

import type { Main } from '@app/store';

import type { AddendumStatus } from '@shared/index';

import type {
  Address,
  AgentDocument,
  BankDetails,
  EmploymentDetails,
  PersonalDocuments,
  Profile,
} from '../types';

//TODO: переименовать в AgentProfileStore, объединить с AgentUserStore и удалить AgentUserStore
export class AgentContractStore {
  private mainStore: Main;
  profile?: Profile;
  agentProfileDraft?: Profile;
  agentDocuments?: AgentDocument[];
  profileAddendumStatus?: AddendumStatus;
  filesToUpdateProfile?: string[];

  constructor(mainStore: Main) {
    this.mainStore = mainStore;
    makeAutoObservable(this);
  }

  setPersonalDocuments = (personalDocument: PersonalDocuments) => {
    this.profile = {
      ...this.profile,
      personalDocument,
    };
  };

  setAddresses = (addressesAgents: Array<Address>) => {
    this.profile = {
      ...this.profile,
      addressesAgents,
    };
  };

  setEmploymentDetails = (employmentDetails: EmploymentDetails) => {
    this.profile = {
      ...this.profile,
      employmentDetails,
    };
  };

  setBankDetails = (bankDetails: BankDetails) => {
    this.profile = {
      ...this.profile,
      bankDetails,
    };
  };

  setAgentDocuments = (documents: AgentDocument[]) => {
    this.agentDocuments = documents;
  };

  setProfileAddendumStatus = (profileAddendumStatus?: AddendumStatus) => {
    this.profileAddendumStatus = profileAddendumStatus;
  };

  setFilesToUpdateProfile = (documents?: string[]) => {
    this.filesToUpdateProfile = documents;
  };

  updateProfile = (newProfile: Profile) => {
    this.profile = {
      ...this.profile,
      ...newProfile,
    };
  };

  updateAgentProfileDraft = (newAgentProfileDraft: Profile) => {
    this.agentProfileDraft = {
      ...this.agentProfileDraft,
      ...newAgentProfileDraft,
    };
  };

  reset() {
    runInAction(() => {
      this.profile = undefined;
      this.agentDocuments = undefined;
      this.agentProfileDraft = undefined;
      this.profileAddendumStatus = undefined;
      this.filesToUpdateProfile = undefined;
    });
  }
}
